import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, prepareRequest } from '@atlas/core';
import { onWithdrawalSanalbankSubmit, PREDEFINED_FORMS } from '@atlas/react-forms';
import { parseWithdrawalQuery } from '@atlas/routing';
import { DefaultPopup, HeaderTitle, Label } from '@atlas/ui';

import { SANALBANK_BANKS } from 'common/constants';
import FormCom from 'common/Form/FormCom';

import { displayWithdrawalSuccessNotification } from '../withdrawalUtils';

const form = PREDEFINED_FORMS.withdrawalSanalbankForm(SANALBANK_BANKS);

export const WithdrawalSanalbankPopup = ({ data: { paymentMethod, redirectUrl }, id }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const data = useMemo(() => parseWithdrawalQuery(redirectUrl), [redirectUrl]);

  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);
  const handleSubmit = useCallback(
    async value => {
      if (isSubmitting) return;
      const request = prepareRequest({
        method: 'POST',
        url: 'payments/sanalbank/withdraw',
      });
      const requestData = {
        ...data,
        ...value,
        bankName: SANALBANK_BANKS[value.bankValue],
        // TODO wil be removed when BE does it not required
        information: value.information || 'empty',
      };

      setIsSubmitting(true);

      try {
        const response = await request(requestData);
        displayWithdrawalSuccessNotification({
          amount: data.amount,
          currency: data.currency,
          paymentMethod,
          response,
        });
      } catch (error) {
        NotificationManager.display({
          data: {
            headerTitle: 'withdrawal_by_sanalbank',
            title: 'failed_sad_emoticon',
          },
          type: 'error',
        });
      } finally {
        handleClose();
      }
    },
    [data, handleClose, isSubmitting, paymentMethod],
  );

  return (
    <DefaultPopup
      className="withdrawal-apexpay"
      headerTitle="withdrawal_by_sanalbank"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <HeaderTitle className="center block-big withdrawal-apexpay__title">
        <div className="title-bold-text">
          <Label message="payment_details" />
        </div>
        <div className="sub-title-text">
          <Label message="please_fill_in_the_fields_below" />
        </div>
      </HeaderTitle>

      <div className="withdrawal-apexpay__content">
        <FormCom
          action={onWithdrawalSanalbankSubmit}
          buttonText="withdrawal"
          disableButton={isSubmitting}
          form={form}
          onSubmit={handleSubmit}
        />
      </div>
    </DefaultPopup>
  );
};

WithdrawalSanalbankPopup.propTypes = {
  data: PropTypes.shape({
    redirectUrl: PropTypes.string,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
